import * as React from "react"
import { cn } from "@/lib/utils"

export interface StatGridProps extends React.HTMLAttributes<HTMLDivElement> {
  columns?: 1 | 2 | 3 | 4
  children: React.ReactNode
}

const gridColsMap = {
  1: "grid-cols-1",
  2: "grid-cols-1 md:grid-cols-2",
  3: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
}

export function StatGrid({
  columns = 4,
  children,
  className,
  ...props
}: StatGridProps) {
  return (
    <div
      className={cn(
        "grid gap-4",
        gridColsMap[columns],
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

